var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.mode},[(_vm.showmain)?_c('div',{class:"main-"+_vm.mode},[_vm._t("main")],2):_vm._e(),(_vm.showmain)?_c('div',{class:"resize-"+_vm.mode}):_vm._e(),_c('div',{staticClass:"athor"},[_vm._t("athor")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }